module.exports = __webpack_public_path__ + "img/boomerang.c4626d31.svg";